import { MessageId } from '@/models/Message';
import { mkTrackAttrs } from '@/analytics/track';
import { ThreadId } from '@/models/Thread';

const PREFIX = 'inline';

// Paper Chip
export const mkPaperChipTrackAttrs = (props: { corpusId: number }) =>
  mkTrackAttrs(`${PREFIX}__paper__chip`, props);

// Paper Menu Open Lit Review Button
export const mkPaperMenuOpenLitReviewBtnTrackAttrs = (props: {
  corpusId: number;
}) => mkTrackAttrs(`${PREFIX}__paper__menu__open_lit_review_btn`, props);

// Paper Menu Open Reader Button
export const mkPaperMenuOpenReaderBtnTrackAttrs = (props: {
  corpusId: number;
}) => mkTrackAttrs(`${PREFIX}__paper__menu__open_reader_btn`, props);

// Paper Menu Open S2 Button
export const mkPaperMenuOpenS2BtnTrackAttrs = (props: { corpusId: number }) =>
  mkTrackAttrs(`${PREFIX}__paper__menu__open_s2_btn`, props);

// Paper Menu Paper QA Button
export const mkPaperMenuPaperQABtnTrackAttrs = (props: { corpusId: number }) =>
  mkTrackAttrs(`${PREFIX}__paper__menu__paper_qa_btn`, props);

// Paper Menu Paper Title
export const mkPaperMenuPaperTitleTrackAttrs = (props: { corpusId: number }) =>
  mkTrackAttrs(`${PREFIX}__paper__menu__paper_title`, props);

// Report Chip
export const mkReportChipTrackAttrs = (props: {
  messageId: MessageId;
  reportId: string;
}) => mkTrackAttrs(`${PREFIX}__report__chip`, props);

// Paper Finder Chip
export const mkPaperFinderChipTrackAttrs = (props: {
  messageId: MessageId;
  threadId: ThreadId;
  widgetId: string;
}) => mkTrackAttrs(`${PREFIX}__paper__finder__chip`, props);

// Table Chip
export const mkTableChipTrackAttrs = (props: {
  messageId: MessageId;
  eventId: string;
  tableId: string;
}) => mkTrackAttrs(`${PREFIX}__table__chip`, props);

// Topic Chip
export const mkTopicChipTrackAttrs = (props: { topicId: number | string }) =>
  mkTrackAttrs(`${PREFIX}__topic__chip`, props);

// Topic Description
export const mkTopicDescriptionTrackAttrs = (props: {
  topicId: number | string;
  isLoading?: boolean;
}) => mkTrackAttrs(`${PREFIX}__topic__description`, props);

// Topic Menu S2 Button
export const mkTopicMenuS2BtnTrackAttrs = (props: {
  topicId: number | string;
}) => mkTrackAttrs(`${PREFIX}__topic__menu__s2_btn`, props);
